import { isArray, isString } from './types';
const merger = (acc, cur) => {
    if (isArray(cur)) {
        return acc.concat(cur);
    }
    if (isString(cur)) {
        return acc.concat([cur]);
    }
    return acc;
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set#Remove_duplicate_elements_from_the_array
const uniqueArray = (...args) => [
    ...new Set(args.reduce(merger, [])),
];
const sorter = (a, b) => a.localeCompare(b);
export const mergeSortArray = (...args) => uniqueArray(...args).sort(sorter);
//# sourceMappingURL=mergeSortArray.js.map